import {
  Swup,
  SwupScriptsPlugin,
  SwupA11yPlugin,
} from '@hh/global.js'

class HHMainContent extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    // Mark scripts to be reloaded
    const headScripts = document.querySelectorAll('head script')
    headScripts.forEach((script) => {
      if (
        script.textContent.includes('Globo') ||
        script.src.includes('globo.formbuilder.index.js')
      ) {
        script.setAttribute('data-swup-reload-script', '')
      }
    })

    // Handle product change
    this.swupProduct = new Swup({
      containers: ['.js-swup-update-main-content', '.js-swup-update-seo'],
      linkSelector: '.js-swup-link',
      timeout: 5000,
      animationScope: 'containers',
      plugins: [
        new SwupScriptsPlugin({
          optin: true,
        }),
        new SwupA11yPlugin()
      ],
    })

    this.swupProduct.hooks.on('visit:start', (visit) => {
      visit.scroll.reset = false
    })
  }
}

customElements.define('hh-main-content', HHMainContent)
